import { Link } from "react-router-dom";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import SEO from "../../components/SEO";
import { SITE_URL } from "../../config/site";
import "./LegalPages.css";

export default function TermsPage() {
  return (
    <>
      <SEO
        title="Términos y condiciones | Imalandia"
        description="Consulta las condiciones de compra, producción, envío y uso de productos personalizados en Imalandia."
        canonical={`${SITE_URL}/terminos`}
      />

      <Header />

      <main className="legal-page">
        <div className="legal-container">
          <p className="legal-eyebrow">CONDICIONES DE COMPRA</p>
          <h1>Términos y condiciones</h1>

          <div className="legal-content">
            <p>Última actualización: 30 de julio de 2026.</p>

            <h2>1. Identificación y contacto</h2>

            <p>
              Titular del sitio: imalandia.com. Para cualquier consulta sobre
              una compra puede escribir a{" "}
              <a href="mailto:info@imalandia.com">info@imalandia.com</a> o
              llamar al <a href="tel:+34646273415">646 273 415</a>.
            </p>

            <h2>2. Objeto y aceptación</h2>

            <p>
              Estas condiciones regulan las compras realizadas en Imalandia.
              Antes de continuar al pago, el cliente puede consultar el
              producto, sus opciones, el precio total, el envío y estas
              condiciones. Al realizar el pedido confirma que las ha leído y
              aceptado.
            </p>

            <h2>3. Productos y personalización</h2>

            <p>
              La mayor parte del catálogo se fabrica o personaliza a partir de
              las opciones, textos e imágenes elegidos por el cliente. El
              cliente debe comprobar que el diseño, las cantidades y los datos
              facilitados son correctos antes de pagar.
            </p>

            <p>
              Las imágenes de la web ayudan a presentar el producto. Puede
              haber pequeñas variaciones de color entre una pantalla y el
              resultado físico por las características de cada dispositivo y
              del proceso de producción.
            </p>

            <h2>4. Material aportado por el cliente</h2>

            <p>
              El cliente declara que puede utilizar las fotografías, logotipos
              y textos enviados y que estos no vulneran derechos de terceros ni
              contienen material ilícito. Autoriza su uso para producir y
              gestionar el pedido.
            </p>

            <h2>5. Precios y pago</h2>

            <p>
              Los precios se expresan en euros e incluyen los impuestos
              aplicables, salvo indicación expresa en contrario. Antes del pago
              se muestra el desglose de productos, envío y total.
            </p>

            <p>
              El pago se realiza con tarjeta mediante Stripe. La producción no
              comienza hasta que el pago queda confirmado. Tras completarlo, el
              cliente recibe la confirmación correspondiente en el correo
              facilitado.
            </p>

            <h2>6. Producción y envío</h2>

            <p>
              La producción suele tardar entre 2 y 5 días laborables desde la
              confirmación del pago. El plazo puede variar según el producto,
              la cantidad o la carga de pedidos; el tiempo de transporte se
              añade al de producción.
            </p>

            <p>
              El envío estándar a España peninsular cuesta 4,95 €. Para
              Baleares, Canarias, Ceuta o Melilla debe consultarse la
              disponibilidad antes de pagar. El cliente debe facilitar una
              dirección completa y correcta.
            </p>

            <h2>7. Cambios y cancelaciones</h2>

            <p>
              Si detecta un error, el cliente debe contactar cuanto antes. Un
              producto personalizado solo podrá modificarse o cancelarse si su
              producción todavía no ha comenzado. Cuando ya se haya iniciado,
              no puede garantizarse el cambio o la cancelación.
            </p>

            <h2>8. Desistimiento y devoluciones</h2>

            <p>
              En los productos no personalizados, la persona consumidora puede
              ejercer el derecho de desistimiento dentro de los 14 días
              naturales siguientes a la recepción, conforme a la normativa
              aplicable.
            </p>

            <p>
              El derecho de desistimiento no se aplica a productos
              confeccionados según las especificaciones del cliente o
              claramente personalizados. Esta excepción no afecta a los
              derechos del cliente si el producto llega defectuoso, dañado o no
              corresponde con lo pedido.
            </p>

            <p>
              El procedimiento completo se encuentra en la{" "}
              <Link to="/devoluciones">Política de devoluciones</Link>.
            </p>

            <h2>9. Incidencias</h2>

            <p>
              Si un producto llega dañado, presenta un defecto o es distinto de
              lo solicitado, debe comunicarse lo antes posible a{" "}
              <a href="mailto:info@imalandia.com">info@imalandia.com</a>,
              indicando el número de pedido y adjuntando fotografías que
              permitan revisar la incidencia.
            </p>

            <h2>10. Datos personales y cookies</h2>

            <p>
              Los datos se tratan para gestionar pedidos, pagos, envíos,
              atención al cliente y obligaciones legales, según la{" "}
              <Link to="/privacidad">Política de privacidad</Link>. La web no
              utiliza cookies de análisis, publicidad o seguimiento; únicamente
              tecnologías técnicas necesarias para su funcionamiento.
            </p>

            <h2>11. Legislación y resolución de conflictos</h2>

            <p>
              Estas condiciones se rigen por la legislación española. Cualquier
              controversia se someterá a los juzgados y tribunales que
              correspondan conforme a la normativa de protección de las
              personas consumidoras.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
